"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _Switcher = _interopRequireDefault(require("../../preact-components/control/Switcher"));

var _section = _interopRequireDefault(require("@insided/deprecated-preact-components/design-system-components/section"));

var _axios = _interopRequireDefault(require("axios"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var successMessage = 'Setting has been updated successfully.';
var errorMessage = "Something went wrong, setting can't be updated. Please try again.";

var PublicTagSettings = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(PublicTagSettings, _Component);

  var _super = _createSuper(PublicTagSettings);

  function PublicTagSettings() {
    var _this;

    (0, _classCallCheck2.default)(this, PublicTagSettings);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      isSettingsCollapsed: false,
      isTagCreationEnabled: false,
      isPublicTagsMandatory: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "componentDidMount", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.fetchPublicTagsMandatorySetting();

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "fetchPublicTagsMandatorySetting", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
      var setAlertMessage, _response$data$public, _response$data$topic, response;

      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setAlertMessage = _this.props.setAlertMessage;
              _context2.prev = 1;
              _context2.next = 4;
              return _axios.default.get('/community/api/config');

            case 4:
              response = _context2.sent;

              _this.setState({
                isTagCreationEnabled: (_response$data$public = response.data['publicTag.creationEnabled']) !== null && _response$data$public !== void 0 ? _response$data$public : false,
                isPublicTagsMandatory: (_response$data$topic = response.data['topic.publicTagRequired']) !== null && _response$data$topic !== void 0 ? _response$data$topic : false
              });

              _context2.next = 12;
              break;

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](1);
              // eslint-disable-next-line no-console
              console.log('Error fetching public tags settings:', _context2.t0);
              setAlertMessage(errorMessage, 'error');

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1, 8]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onTogglePublicTagsRequiredSetting", /*#__PURE__*/function () {
      var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(key, value) {
        var setAlertMessage, data;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                setAlertMessage = _this.props.setAlertMessage;
                data = key === 'isPublicTagsMandatory' ? {
                  'topic.publicTagRequired': String(!_this.state.isPublicTagsMandatory)
                } : {
                  'publicTag.creationEnabled': String(!_this.state.isTagCreationEnabled)
                };

                _this.setState(function (prevState) {
                  return _objectSpread(_objectSpread({}, prevState), {}, (0, _defineProperty2.default)({}, key, value));
                });

                _context3.prev = 3;
                _context3.next = 6;
                return _axios.default.post('/community/api/config', data);

              case 6:
                setAlertMessage(successMessage, 'success');
                _context3.next = 13;
                break;

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3["catch"](3);
                // eslint-disable-next-line no-console
                console.log('Error saving public tags settings:', _context3.t0);
                setAlertMessage(errorMessage, 'error');

              case 13:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[3, 9]]);
      }));

      return function (_x, _x2) {
        return _ref3.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onToggleCollapseSettings", function () {
      _this.setState(function (prevState) {
        return {
          isSettingsCollapsed: !prevState.isSettingsCollapsed
        };
      });
    });
    return _this;
  }

  (0, _createClass2.default)(PublicTagSettings, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          isTagCreationEnabled = _this$state.isTagCreationEnabled,
          isSettingsCollapsed = _this$state.isSettingsCollapsed,
          isPublicTagsMandatory = _this$state.isPublicTagsMandatory;
      return (0, _preact.h)("div", {
        className: "public-tag-panel-with-margin qa-public-tag-creation-setting"
      }, (0, _preact.h)(_section.default, {
        title: "Settings",
        onToggleCollapse: this.onToggleCollapseSettings,
        isCollapsed: isSettingsCollapsed
      }, (0, _preact.h)(_Switcher.default, {
        on: isTagCreationEnabled,
        label: "Allow end users to add new public tags",
        customClass: "public-tag-switcher--with-margin qa-public-tag-creation-switch",
        onChange: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
          return _regenerator.default.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  _context4.next = 2;
                  return _this2.onTogglePublicTagsRequiredSetting('isTagCreationEnabled', !isTagCreationEnabled);

                case 2:
                  return _context4.abrupt("return", _context4.sent);

                case 3:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4);
        }))
      }), (0, _preact.h)(_Switcher.default, {
        on: isPublicTagsMandatory,
        label: "Mark public tags as mandatory in destination while creating a topic",
        customClass: "qa-public-tag-mandatory-switch",
        onChange: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5() {
          return _regenerator.default.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  _context5.next = 2;
                  return _this2.onTogglePublicTagsRequiredSetting('isPublicTagsMandatory', !isPublicTagsMandatory);

                case 2:
                  return _context5.abrupt("return", _context5.sent);

                case 3:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5);
        }))
      })));
    }
  }]);
  return PublicTagSettings;
}(_preact.Component);

var _default = PublicTagSettings;
exports.default = _default;